<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/27LJCt/tc-custom/9781504071758.jpg?1703826300873" alt="This image is the cover for the book Good Messenger"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Good Messenger
      </h1>
      <p class="bookDescription body article font2">
        <b>In the volatile decades of the early twentieth century, a prominent family keeps its secrets hidden—but war will expose them . . .</b><br/><br/>1912. A young boy, Tom Shepherd, is invited to stay at Hardinge Hall. Mr and Mrs Hardinge are trying to arrange the marriage of their son Teddy to Iris, the daughter of a local businessman. Tom becomes the innocent messenger who delivers the secret arrangements. <br/><br/>Armistice Day 1918. The First World War has changed everything, especially the closeted world that Iris, Teddy, and Tom existed in. Will things ever be the same again? <br/><br/>1927. Tom is now a journalist investigating the discovery of a baby’s bones in the woods around Hardinge Hall—and the past and present move towards a resolution that could bring everything crashing down . . .<br/><br/>From the author of <i>Spanish Crossings</i>, <i>The Good Messenger</i> is an epic tale of love, loyalty, and deception spanning two tumultuous decades.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Simmons
      </h2>
      
      <p class="authorDescription body article">A distinguished career as a brand consultant has turned into a parallel life as a novelist in recent years.  John was a director of Interbrand where he created the brand discipline of tone of voice, working internationally with some of the world’s most famous companies. He became a freelance writer while establishing two organisations for writers – 26 and Dark Angels. For Dark Angels, named after John’s book on writing creatively for business, he continues to run writing workshops that have become legendary. He was awarded an Honorary Fellowship by the University of Falmouth for ‘outstanding contribution to the creative sector’.  John’s first novel Leaves was originally published by Urbane in 2015, having been in his head since university days. This quickly led to Spanish Crossings, with the Spanish Civil War and a family story as background. His third novel The Good Messenger is set on Armistice Day 1918 and on either side of the first world war.  Above all John believes in the power of storytelling.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?99506f18